
import React, {} from 'react'
import {  Typography, Box, Card, CardContent } from '@mui/material';

import { useMediaPredicate } from "react-media-hook";


interface InfoProps{
    name: string
    email: string
}
function InfoBox(props:InfoProps){
    const RheoSuite_Transparent_white = require('../../assets/rheosuite_white.png' )
    const {name, email} = props
    const isMobile = useMediaPredicate("(max-width: 600px)");
    const isXS = useMediaPredicate("(max-width: 400px)");
    let height = '90px'
    if (isMobile){
        height = '80px'
    }
    if (isXS){
        height = '60px'
    }

    return (
        <Box >
            <Card variant="outlined" sx={{ minWidth: 330, margin: 2 , backgroundColor: "#0A1929"}}>
                <CardContent>
                    <img src={RheoSuite_Transparent_white} alt="rheosuite logo" style={{width:"auto", height:height, maxHeight:'98px', marginBottom:'20px'}}/>
                    <Typography variant="h5" component="div" color="white" sx={{mb:1}}>
                        Welcome {name} Below is a list of your skids navigate to your desired page with the buttons on each skid
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    )
}

export default InfoBox